import React from "react";
import { Card, Typography, Image, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "./BlogDetail.css"; // Assuming you create a CSS file for styling

const { Title, Paragraph } = Typography;

const BlogDetail = () => {
  const { state: blog } = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/blog"); // Adjust the route as per your application structure
  };

  if (!blog) {
    return (
      <Card title="Blog Details" style={{ margin: "20px", textAlign: "center" }}>
        <Paragraph>No blog details available.</Paragraph>
        <Button type="primary" onClick={handleBack} style={{ marginTop: "10px" }}>
          Back to Blog
        </Button>
      </Card>
    );
  }

  return (
    <div className="blog-detail-container">
      <Card
        title={
          <div className="blog-detail-header">
            <Title level={3}>Blog Details</Title>
            <Button type="primary" onClick={handleBack}>
              Back to Blog
            </Button>
          </div>
        }
        className="blog-detail-card"
      >
        <Image
          src={blog.image}
          alt={blog.title}
          className="blog-detail-image"
        />
        <Title level={3} className="blog-detail-title">
          {blog.title}
        </Title>
        <Paragraph className="blog-detail-description">{blog.description}</Paragraph>
      </Card>
    </div>
  );
};

export default BlogDetail;